module.exports = __webpack_public_path__ + "img/phpunit.d504f61a.png";